<template>
    <div class="card">
        <div class="card-body">
            <h4 class="title text-primary mb-0">{{ heading }}</h4>
            <table class="table table-striped">
                <thead>
                    <tr class="border-2 border-bottom">
                        <th v-for="(header, i) in headers"
                            :class="{
                                'text-end pe-3': i === (headers.length - 1),
                                'ps-4': i === 0,
                            }"
                            class="fw-normal"
                            :key="i">
                            {{ header.name }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <template v-if="loading">
                        <tr>
                            <td :colspan="headers.length">
                                <Spinner spinner-type="grow" min-height="320px" />
                            </td>
                        </tr>
                    </template>
                    <template v-else-if="rows.length">
                        <tr v-for="(row, i) in rows" :key="i">
                            <td v-for="(header, j) in headers"
                                :class="{
                                    'text-end pe-3': j === (headers.length - 1),
                                    'ps-4': j === 0,
                                }"
                                :key="j">
                                {{ typeof header.value === 'function'
                                    ? header.value(row, i, header, j)
                                    : data_get(row, header.value)
                                }}
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr>
                            <td :colspan="headers.length">
                                <div class="d-flex justify-content-center align-items-center"
                                    style="min-height: 320px">
                                    {{ __('No data found') }}
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
            <div v-if="showPagination" class="d-flex justify-content-end align-items-center gap-3 table-pagination">
                <p>
                    {{ __('Rows') }}
                    {{ en_to_bn(pagination.from) }}-{{ en_to_bn(pagination.to) }}
                    {{ __('of') }}
                    {{ en_to_bn(pagination.total) }}
                </p>
                <div class="d-flex align-items-center gap-3">
                    <svg v-on="{ click: loading ? null : prevPage }" width="9" height="18" viewBox="0 0 9 18"
                        :class="{ active: pagination.current_page > 1 && !loading }" xmlns="http://www.w3.org/2000/svg"
                        fill="none">
                        <path
                            d="M0.224654 9.21617C0.102004 9.09815 0.102004 8.90185 0.224654 8.78383L8.49199 0.82858C8.68258 0.645184 9 0.780255 9 1.04475L9 16.9552C9 17.2197 8.68258 17.3548 8.49199 17.1714L0.224654 9.21617Z"
                            fill="#B8BBC3" />
                    </svg>
                    <svg v-on="{ click: loading ? null : nextPage }" width="9" height="18" viewBox="0 0 9 18"
                        :class="{ active: pagination.current_page < pagination.last_page && !loading }"
                        xmlns="http://www.w3.org/2000/svg" fill="none">
                        <path
                            d="M8.77535 8.78383C8.898 8.90185 8.898 9.09815 8.77535 9.21617L0.508012 17.1714C0.317421 17.3548 -4.17232e-07 17.2197 -4.17232e-07 16.9552L-4.17232e-07 1.04475C-4.17232e-07 0.780256 0.317421 0.645185 0.508012 0.828582L8.77535 8.78383Z"
                            fill="#B8BBC3" />
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Spinner from '../../components/Spinner';

export default {
    components: {
        Spinner,
    },

    emits: ['change:page'],

    props: {
        heading: { type: String, required: true },
        headers: { type: Array, required: true },
        rows: { type: Array, default: [] },
        loading: { type: Boolean, default: false },
        showPagination: { type: Boolean, default: true },
        pagination: {
            type: Object,
            default: {
                current_page: 1,
                last_page: 1,
                per_page: 10,
                total: 0,
                from: 0,
                to: 0,
            },
        },
    },

    methods: {
        prevPage() {
            if (this.pagination.current_page > 1) {
                this.resetRowCount();
                this.pagination.current_page -= 1;
                this.$emit('change:page', this.pagination.current_page);
            }
        },

        nextPage() {
            if (this.pagination.current_page < this.pagination.last_page) {
                this.resetRowCount();
                this.pagination.current_page += 1;
                this.$emit('change:page', this.pagination.current_page);
            }
        },

        resetRowCount() {
            this.pagination.from = 0;
            this.pagination.to = 0;
            this.pagination.total = 0;
        },
    },
}
</script>